<template>
    <div  >
            <top-navbar></top-navbar>


            <div  class="mb-5  background_color " >


                <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Maintainence Management   </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/pdf/index">Maintainence List</router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Advanced Search </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
                <div style=" padding-bottom: 100px;" class="container-fluid ">
                <div class="card bdr-rad2 mt-1 shadow p-2 ">
                <div class="card-body">
                <b-modal :id="infoModal.id" :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant" bottom>
                <template #modal-title>
                  <h4>File Name</h4>
                </template>
                <div class="d-block text-center">
                 <input
        type="text"
        class="form-control font-size_def"
        v-model="filename"
      />
                </div>
<!-- //:disabled="isSaving" -->
                <template #modal-footer>
                  <button style="font-size: small;" @click="Savefile()" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad"> {{ isSaving ? 'Saving...' : 'Save' }}</button>
                  <button style="font-size: small;" @click="$bvModal.hide(infoModal.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">Cancel</button>
                </template>
              </b-modal>

                  <table style="font-size: small; " class="table table-hover  table-sm table-borderless  ">

                        <tbody >


                          <tr>
                            <td class="width-custom2"><b>Supplier </b></td>
                           <td class="width-custom4">Boeing</td>
                           <td><b-form-checkbox v-model="supall.sup" /></td>
                          </tr>
                          <tr>
                            <td><b>Model & Series  </b></td>
                           <td>737-8</td>
                            <td><b-form-checkbox v-model="supall.model" /></td>
                          </tr>
                          <tr>
                            <td><b>Aircraft Number </b></td>
                           <td>1K016</td>
                            <td><b-form-checkbox v-model="supall.airnum" /></td>
                          </tr>

                          <tr>
                            <td><b>Aircraft Serial Number   </b></td>
                           <td>44304</td>
                            <td><b-form-checkbox v-model="supall.srila" /></td>
                          </tr>
                          <tr>
                            <td><b>Engine Serial Number 1 </b></td>
                           <td></td>
                            <td><b-form-checkbox v-model="supall.eng1" /></td>
                          </tr>
                          <tr>
                            <td><b>Engine Serial Number 2 </b></td>
                           <td></td>
                             <td><b-form-checkbox v-model="supall.eng2" /></td>
                          </tr>
                          <tr>
                            <td><b>APU Serial Number</b></td>
                           <td></td>
                             <td><b-form-checkbox v-model="supall.apuseril" /></td>
                          </tr>
                          <tr>
                            <td><b>Landing Serial Number </b></td>
                           <td></td>
                             <td><b-form-checkbox v-model="supall.lanserial" /></td>
                          </tr>




                        </tbody>


                      </table>

<table class="table table-borderless">
<tr v-for="(alldata, index) in rows" :key="index">

<td>
<div  class="row mb-2">


  <div class="col-md-3">
    <div class="form-group required">
      <label class="custom-label" style="font-size: small;">File</label>
      <v-select
  class="font-size_def"
  label="label"
 :options="getFilteredFiles(index)"
  v-model="alldata.selectfile"
  @input="loadtab(alldata)"
/>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group required">
      <label class="custom-label" style="font-size: small;">Tab</label>
     <v-select
  class="font-size_def"
  label="label"
    @input="loadcoulm(alldata)"
  :options="alldata.sections || []"
  v-model="alldata.selecttab"
  multiple
  :close-on-select="false"
/>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group">
      <label class="custom-label" style="font-size: small;">Column</label>
     <v-select
  class="font-size_def"
  label="label"
  :options="alldata.sectioncolum || []"
  v-model="alldata.seleccolum"
  multiple
  :close-on-select="false"
/>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group required">
      <label class="custom-label" style="font-size: small;">Keywords</label>
      <input
        type="text"
        class="form-control font-size_def"
        v-model="alldata.keyword"
      />
    </div>
  </div>
  </div>
</td>
<td style="width: 100px;">
  <div class="row">
  <div class="col-md-3 mt-3
   d-flex align-items-center">
    <button class="btn btn-outline-primary btn-sm mt-2 bdr-rad" @click="addRow" title="Add Row">
      +
    </button>

    <button
      v-if="rows.length > 1"
      class="btn btn-outline-primary btn-sm mt-2 ml-2 bdr-rad"
      @click="removeRow(index)"
      title="Remove Row"
    >
      -
    </button>
  </div>
  </div>
</td>
</tr>
</table>




















    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">

    <div class="d-flex  ">

    </div>
   <div  class="d-grid  ">
  <button  @click="loadMiinventory()" style="margin-bottom: 0px;" class="mr-1  btn btn-sm btn-outline-primary  mb-2 bdr-rad" type="button">Search</button>
  <button @click="Savedata()" style="margin-top: 0px;" class="mr-1 mb-2 btn btn-sm btn-outline-primary bdr-rad" type="button">Save Result</button>
  <button @click="clearForm()" style="margin-top: 0px;" class="mr-1 btn btn-sm btn-outline-primary bdr-rad" type="button">Clear All</button>

</div>
    </div>

    <br><br>

<div class="d-flex justify-content-center" v-if="isLoading">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>



      <div>

 <button class="btn btn-outline-primary btn-sm bdr-rad" @click="Remove()">Remove</button>


      <div v-if="table1" style="border: 0px; padding: 0px; min-height:0px" class="navbar ">

        <div class="d-flex">
          <div  class="" >
          <span class="custom-breadcrumb"><b>Showing  {{totalRowsarl}} items.   ARL</b></span>
          </div>

        </div>


        <div class="d-grid gap-2 d-md-flex justify-content-md-end">

        </div>

      </div>


 <div v-if="table1" class="table-responsive">


    <b-table
  responsive
  style="font-size: small;"
  class="table-hover"
  :items="filteredDataArl"
  :fields="visibleFieldsarl"
  head-variant="dark"
  show-empty
  small
>
    <template #cell(check_box)="row">
  <b-form-checkbox v-model="row.item.selected" />
</template>
<template #head(mpd_mid)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input
      v-model="columnFilters.mpd_mid"
      placeholder="Search"
      size="sm"
    />
  </div>
</template>

<template #head(part_num_dis)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input
      v-model="columnFilters.part_num_dis"
      placeholder="Search"
      size="sm"
    />
  </div>
</template>

<template #head(cage_code)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input
      v-model="columnFilters.cage_code"
      placeholder="Search"
      size="sm"
    />
  </div>
</template>

<template #head(qty)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input
      v-model="columnFilters.qty"
      placeholder="Search"
      size="sm"
    />
  </div>
</template>

<template #head(serial)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input
      v-model="columnFilters.serial"
      placeholder="Search"
      size="sm"
    />
  </div>
</template>

<template #head(misc_loc)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input
      v-model="columnFilters.misc_loc"
      placeholder="Search"
      size="sm"
    />
  </div>
</template>
    </b-table>

  </div>



  <div v-if="table2" style="border: 0px; padding: 0px; min-height:0px" class="navbar ">

        <div class="d-flex">
          <div  class="" >
          <span class="custom-breadcrumb"><b>Showing  {{totalRowsad}} items.  Airworthiness Directive</b></span>
          </div>

        </div>


        <div class="d-grid gap-2 d-md-flex justify-content-md-end">

        </div>

      </div>


   <div v-if="table2" class="table-responsive">


   <b-table
  responsive
  style="font-size: small;"
  class="table-hover"
  :items="filteredDataAd"
  :fields="visibleFieldsad"
  head-variant="dark"
  show-empty
  small
>
    <template #cell(check_box)="row">
  <b-form-checkbox v-model="row.item.selected" />
</template>
<template #head(ad_number)="data">
    <div class="d-flex flex-column">
      <span>{{ data.label }}</span>
      <b-form-input
        v-model="columnFiltersAd.ad_number"
        placeholder="Search"
        size="sm"
      />
    </div>
  </template>

  <template #head(amendment)="data">
    <div class="d-flex flex-column">
      <span>{{ data.label }}</span>
      <b-form-input
        v-model="columnFiltersAd.amendment"
        placeholder="Search"
        size="sm"
      />
    </div>
  </template>

  <template #head(assigned)="data">
    <div class="d-flex flex-column">
      <span>{{ data.label }}</span>
      <b-form-input
        v-model="columnFiltersAd.assigned"
        placeholder="Search"
        size="sm"
      />
    </div>
  </template>

  <template #head(subject)="data">
    <div class="d-flex flex-column">
      <span>{{ data.label }}</span>
      <b-form-input
        v-model="columnFiltersAd.subject"
        placeholder="Search"
        size="sm"
      />
    </div>
  </template>

  <template #head(compliance)="data">
    <div class="d-flex flex-column">
      <span>{{ data.label }}</span>
      <b-form-input
        v-model="columnFiltersAd.compliance"
        placeholder="Search"
        size="sm"
      />
    </div>
  </template>

  <template #head(additional_information)="data">
    <div class="d-flex flex-column">
      <span>{{ data.label }}</span>
      <b-form-input
        v-model="columnFiltersAd.additional_information"
        placeholder="Search"
        size="sm"
      />
    </div>
  </template>
    </b-table>

  </div>





   <div v-if="table3" style="border: 0px; padding: 0px; min-height:0px" class="navbar ">

        <div class="d-flex">
          <div  class="" >
          <span class="custom-breadcrumb"><b>Showing  {{totalRowsmpdjan}} items.  Mpd 01-01-2024</b></span>
          </div>

        </div>


        <div class="d-grid gap-2 d-md-flex justify-content-md-end">

        </div>

      </div>


   <div v-if="table3" class="table-responsive">


   <b-table
  responsive
  style="font-size: small;"
  class="table-hover table-responsive"
  :items="filteredDataMpdjan"
  :fields="visibleFieldsmpdjan"
  head-variant="dark"
  show-empty
  small
>
       <template #cell(check_box)="row">
  <b-form-checkbox v-model="row.item.selected" />
</template>
<template #head(section)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.section" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(item)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.item" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(item_number)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.item_number" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(mrb_item_number)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.mrb_item_number" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(amm_reference)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.amm_reference" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(pgm)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.pgm" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(cat)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.cat" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(task)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.task" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(task_card_number)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.task_card_number" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(related_task_card_number)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.related_task_card_number" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(task_title)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.task_title" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(thres)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.thres" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(repeat)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.repeat" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(zone)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.zone" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(access)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.access" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(apl)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.apl" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(eng)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.eng" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(main_hours)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.main_hours" placeholder="Search" size="sm" />
  </div>
</template>

<template #head(description_of_change)="data">
  <div class="d-flex flex-column">
    <span>{{ data.label }}</span>
    <b-form-input v-model="columnFiltersMpdjan.description_of_change" placeholder="Search" size="sm" />
  </div>
</template>

    </b-table>

  </div>


   <div v-if="table4" style="border: 0px; padding: 0px; min-height:0px" class="navbar ">

        <div class="d-flex">
          <div  class="" >
          <span class="custom-breadcrumb"><b>Showing  {{totalRowsmpdsep}} items. Mpd 15-09-2024</b></span>
          </div>

        </div>


        <div class="d-grid gap-2 d-md-flex justify-content-md-end">

        </div>

      </div>


   <div v-if="table4" class="table-responsive">


  <b-table
  responsive
  class="table-hover table-responsive"
  style="font-size: small;"
 :items="filteredDataMpdsep"
  :fields="visibleFieldsmpdsep"
  head-variant="dark"
  show-empty
  small
>
     <template #cell(check_box)="row">
  <b-form-checkbox v-model="row.item.selected" />
</template>

  <template v-for="field in Object.keys(columnFiltersMpdsep)" v-slot:[`head(${field})`]="data">
    <div class="d-flex flex-column">
      <span>{{ data.label }}</span>
      <b-form-input
        v-model="columnFiltersMpdsep[field]"
        placeholder="Search"
        size="sm"
      />
    </div>
  </template>
    </b-table>

  </div>




      </div>









                </div>
                </div>

            </div>

          </div>

            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'



      export default {
watch: {
  rows: {
    handler(newRows) {
      localStorage.setItem('savedRows', JSON.stringify(newRows));
    },
    deep: true
  },

   filteredDataMpdsep(newVal) {
    this.totalRowsmpdsep = newVal.length;
  },
  filteredDataArl(newVal) {
    this.totalRowsarl = newVal.length;
  },
  filteredDataAd(newVal) {
    this.totalRowsad = newVal.length;
  },
  filteredDataMpdjan(newVal) {
    this.totalRowsmpdjan = newVal.length;
  }
},
        mounted(){
          const saved = localStorage.getItem('savedRows');
  if (saved) {
    this.rows = JSON.parse(saved);
  }

      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            table1 :false,
            table2 :false,
            table3 :false,
             isSaving: false,
            table4 :false,
            isLoading:false,
            file: null,
            filename:'',
            // alldata:{
            //   'keyword':'',
            // },

              rows: [
      {
        selectfile: null,
        selecttab: [],
        keyword: '',
        sections: []
      }
    ],
      columnFilters: {
      mpd_mid: '',
      part_num_dis: '',
      cage_code: '',
      qty: '',
      serial: '',
      misc_loc: ''
    },
    columnFiltersAd: {
  ad_number: '',
  amendment: '',
  assigned: '',
  subject: '',
  compliance: '',
  additional_information: ''
},
columnFiltersMpdjan: {
  section: '',
  item: '',
  item_number: '',
  mrb_item_number: '',
  amm_reference: '',
  pgm: '',
  cat: '',
  task: '',
  task_card_number: '',
  related_task_card_number: '',
  task_title: '',
  thres: '',
  repeat: '',
  zone: '',
  access: '',
  apl: '',
  eng: '',
  main_hours: '',
  description_of_change: ''
},
columnFiltersMpdsep: {
  section: '',
  item: '',
  item_number: '',
  mrb_item_number: '',
  amm_reference: '',
  pgm: '',
  cat: '',
  task: '',
  task_card_number: '',
  related_task_card_number: '',
  task_title: '',
  thres: '',
  repeat: '',
  zone: '',
  access: '',
  apl: '',
  eng: '',
  main_hours: '',
  description_of_change: ''
},
      Fileselcts: [ ],

      supall:{
        'sup':'',
        'model':'',
          'airnum':'',
        'srila':'',
      
      },

        filter: null,

        filterOn: [],
        totalRowsarl: 0,
        totalRowsad: 0,
        totalRowsmpdjan: 0,
        totalRowsmpdsep: 0,

        infoModal: {
                id: 'info-modal',
                title: '',
                content: {},
              },

                all_data_arl:[],

                 field_arl: [
                      { key: 'check_box', label: 'Select', sortable: true,  },
          { key: 'mpd_mid', label: 'MPD MID#', sortable: true,  },
          { key: 'part_num_dis', label: 'Part Number Part Description', sortable: true  },
          { key: 'cage_code', label: 'Search (Click to sort ascending) Used On/Alt Authority Cage Code/SRC/ATA/LL/PV/AD', sortable: true  },
          { key: 'qty', label: 'Qty', sortable: true  },
          { key: 'serial', label: 'Serial/Lot Number/Dates', sortable: true  },
          { key: 'misc_loc', label: 'Misc Loc/Ref Designator X-Station/Y-BL/Z-Wtr', sortable: true  },


        ],


             all_data_ad:[],

                 field_ad: [
                      { key: 'check_box', label: 'Select', sortable: true,  },
          { key: 'ad_number', label: 'AD Number Effective Date', sortable: true,  },
          { key: 'amendment', label: 'Amendment', sortable: true  },
          { key: 'assigned', label: 'Assigned to', sortable: true  },
          { key: 'subject', label: 'Subject', sortable: true  },
          { key: 'compliance', label: 'Compliance/Limitations', sortable: true  },
          { key: 'additional_information', label: 'Follow-on Action / Additional Information', sortable: true  },


        ],


             all_data_mpdjan:[],

                 field_mpdjan: [
                      { key: 'check_box', label: 'Select', sortable: true,  },
      { key: 'section', label: 'Section', sortable: true,  },
          { key: 'item', label: 'Item', sortable: true  },
          { key: 'item_number', label: 'MPD ITEM NUMBER', sortable: true  },
          { key: 'mrb_item_number', label: 'MRB ITEM NUMBER', sortable: true  },
          { key: 'amm_reference', label: 'AMM REFERENCE', sortable: true  },
          { key: 'pgm', label: 'PGM', sortable: true  },
          { key: 'cat', label: 'CAT', sortable: true  },
          { key: 'task', label: 'TASK', sortable: true  },
          { key: 'task_card_number', label: 'TASK CARD NUMBER', sortable: true  },
          { key: 'related_task_card_number', label: 'RELATED TASK CARD NUMBER', sortable: true  },
          { key: 'task_title', label: 'TASK TITLE', sortable: true  },
          { key: 'thres', label: 'THRE S.', sortable: true  },
          { key: 'repeat', label: 'REPEAT', sortable: true  },
          { key: 'zone', label: 'ZONE', sortable: true  },
          { key: 'access', label: 'ACCESS', sortable: true  },
          { key: 'apl', label: 'APL', sortable: true  },
          { key: 'eng', label: 'ENG', sortable: true  },
          { key: 'main_hours', label: 'MAIN-HOURS', sortable: true  },
          { key: 'description_of_change', label: 'Description', sortable: true  },



        ],


             all_data_mpdsep:[],

                 field_mpdsep: [
                      { key: 'check_box', label: 'Select', sortable: true,  },
           { key: 'section', label: 'Section', sortable: true,  },
          { key: 'item', label: 'Item', sortable: true  },
          { key: 'item_number', label: 'MPD ITEM NUMBER', sortable: true  },
          { key: 'mrb_item_number', label: 'MRB ITEM NUMBER', sortable: true  },
          { key: 'amm_reference', label: 'AMM REFERENCE', sortable: true  },
          { key: 'pgm', label: 'PGM', sortable: true  },
          { key: 'cat', label: 'CAT', sortable: true  },
          { key: 'task', label: 'TASK', sortable: true  },
          { key: 'task_card_number', label: 'TASK CARD NUMBER', sortable: true  },
          { key: 'related_task_card_number', label: 'RELATED TASK CARD NUMBER', sortable: true  },
          { key: 'task_title', label: 'TASK TITLE', sortable: true  },
          { key: 'thres', label: 'THRE S.', sortable: true  },
          { key: 'repeat', label: 'REPEAT', sortable: true  },
          { key: 'zone', label: 'ZONE', sortable: true  },
          { key: 'access', label: 'ACCESS', sortable: true  },
          { key: 'apl', label: 'APL', sortable: true  },
          { key: 'eng', label: 'ENG', sortable: true  },
          { key: 'main_hours', label: 'MAIN-HOURS', sortable: true  },
          { key: 'description_of_change', label: 'Description', sortable: true  },


        ],




            sections:[
            { label: 'Section1', value: 'section1' },
            { label: 'Section2', value: 'section2' },
            { label: 'Section3', value: 'section3' },
            { label: 'Section4', value: 'section4' },

          ],

             Fileselcts:[
            { label: 'Detailed Specification', value: 'detailed_specification' },
            { label: 'ARL', value: 'arl' },
            { label: 'Airworthiness Directive', value: 'airworthiness_directive' },
            { label: 'MPD 01-01-2024', value: 'MPD_01-01-2024' },
            { label: 'MPD 15-09-2024', value: 'MPD_15-09-2024' },

          ],


          variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark', 'mycoolor'],
      headerBgVariant: 'mycoolor',
      headerTextVariant: 'light',




          }

        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,

        },



        computed: {
      filteredDataMpdjan() {
    return this.all_data_mpdjan.filter(row => {
      return Object.keys(this.columnFiltersMpdjan).every(key => {
        const filter = this.columnFiltersMpdjan[key].toLowerCase();
        const value = String(row[key] || '').toLowerCase();
        return value.includes(filter);
      });
    });
  },

    totalRowsmpdjan() {
    return this.filteredDataMpdjan.length;


  },
   visibleFieldsmpdjan() {
  if (!this.all_data_mpdjan || this.all_data_mpdjan.length === 0) {
    return this.field_mpdjan;
  }

  return this.field_mpdjan.filter(field => {
    const key = field.key;

    // Always include checkbox fields
    if (key === 'selected' || key === 'check_box') {
      return true;
    }

    return this.all_data_mpdjan.some(row => {
      const value = row[key];
      return value !== null && value !== undefined && String(value).trim() !== '';
    });
  });
},

filteredDataMpdsep() {

    return this.all_data_mpdsep.filter(row => {
      return Object.keys(this.columnFiltersMpdsep).every(key => {
        const filterValue = this.columnFiltersMpdsep[key].toLowerCase();
        const rowValue = String(row[key] || '').toLowerCase();
        return rowValue.includes(filterValue);
      });
    });
  },
  totalRowsmpdsep() {
    return this.filteredDataMpdsep.length;


  },

   visibleFieldsmpdsep() {
  if (!this.all_data_mpdsep || this.all_data_mpdsep.length === 0) {
    return this.field_mpdsep;
  }

  return this.field_mpdsep.filter(field => {
    const key = field.key;

    // Always include checkbox fields
    if (key === 'check_box') {
      return true;
    }

    return this.all_data_mpdsep.some(row => {
      const value = row[key];
      return value !== null && value !== undefined && String(value).trim() !== '';
    });
  });
},


  filteredDataArl() {
    return this.all_data_arl.filter(row => {
      return Object.keys(this.columnFilters).every(key => {
        const filter = this.columnFilters[key].toLowerCase();
        const value = String(row[key] || '').toLowerCase();
        return value.includes(filter);
      });
    });
  },

  totalRowsarl() {
    return this.filteredDataArl.length;


  },


visibleFieldsarl() {
  return this.field_arl;
},

 filteredDataAd() {
    return this.all_data_ad.filter(row => {
      return Object.keys(this.columnFiltersAd).every(key => {
        const filter = this.columnFiltersAd[key].toLowerCase();
        const value = String(row[key] || '').toLowerCase();
        return value.includes(filter);
      });
    });
  },

  totalRowsad() {
    return this.filteredDataAd.length;


  },



 visibleFieldsad() {
  if (!this.all_data_ad || this.all_data_ad.length === 0) {
    return this.field_ad;
  }

  return this.field_ad.filter(field => {
    const key = field.key;

    // Always include checkbox fields (adjust 'check_box' to your actual key name if different)
    if (key === 'check_box' || key === 'selected') {
      return true;
    }

    return this.all_data_ad.some(row => {
      const value = row[key];
      return value !== null && value !== undefined && String(value).trim() !== '';
    });
  });
},




},

        methods : {





 clearForm() {

       this.table1 = false;
       this.table2 = false;
       this.table3 = false;
       this.table4 = false;
    this.rows = [
      {
        selectfile: null,
        selecttab: [],
        seleccolum: [],
        keyword: '',
        sections: [],
        sectioncolum: []
      }
    ];
    localStorage.removeItem('savedRows');
  },

          Savedata(){

             this.infoModal.content = 1;
              this.$root.$emit('bv::show::modal', this.infoModal.id)
          },

    getFilteredFiles(currentIndex) {
  const selectedValues = this.rows
    .map((row, i) => i !== currentIndex ? (row.selectfile && row.selectfile.value) : null)
    .filter(val => val !== null);

  return this.Fileselcts.filter(option => !selectedValues.includes(option.value));
},

  addRow() {
    this.rows.push({
      selectfile: null,
      selecttab: [],
      keyword: ''
    });
  },
   removeRow(index) {
    this.rows.splice(index, 1);
  },
  loadtab(rowIndex) {
    // Optional: you can react to file change per row
    console.log('File changed in row', rowIndex);
  },


  async Remove() {
  // Remove ALL selected items from each data array

  this.all_data_arl = this.all_data_arl.filter(item => !item.selected);
  console.log('Updated ARL data:', this.filteredDataArl);

  this.all_data_ad = this.all_data_ad.filter(item => !item.selected);
  console.log('Updated AD data:', this.filteredDataAd);

  this.all_data_mpdjan = this.all_data_mpdjan.filter(item => !item.selected);
  console.log('Updated MPD JAN data:', this.filteredDataMpdjan);

  this.all_data_mpdsep = this.all_data_mpdsep.filter(item => !item.selected);
  console.log('Updated MPD SEP data:', this.filteredDataMpdsep);
},


    async Savefile() {
 this.isSaving = true;
   console.log(this.filteredDataArl);

      try {
       // this.isLoading = true;
        const { data } = await axios.post('/mproduct/pdfsave',{all_data_arl:this.filteredDataArl,all_data_ad:this.filteredDataAd,all_data_mpdjan:this.filteredDataMpdjan,all_data_mpdsep:this.filteredDataMpdsep,filename:this.filename,userid:this.userid}, {

          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          }
        });
        console.log(data);
        if(data.status==200){
   this.$root.$emit('bv::hide::modal', this.infoModal.id);
   alert("file "+this.filename+" created");


        }



        // this.isLoading = false;
      } catch (error) {
        console.log(error.response);
      }
    },

            async loadMiinventory() {
      this.isLoading = true;
       this.table1 = false;
       this.table2 = false;
       this.table3 = false;
       this.table4 = false;
            console.log(this.rows);

      try {
       // this.isLoading = true;
        const { data } = await axios.post('/mproduct/pdfsearch',{rows:this.rows,supall:this.supall}, {

          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          }
        });
        console.log(data);
        if(data.status==200){
          this.isLoading = false;
        this.all_data_arl = data.all_data_arl;
        this.totalRowsarl = data.totalRowsarl;
          this.all_data_ad = data.all_data_ad;
          this.totalRowsad = data.totalRowsad;
           this.all_data_mpdjan = data.all_data_mpdjan;
          this.totalRowsmpdjan = data.totalRowsmpdjan;
           this.all_data_mpdsep = data.all_data_mpdsep;
          this.totalRowsmpdsep = data.totalRowsmpdsep;



           if(this.totalRowsarl>0){
          this.table1 = true;
        }
         if(this.totalRowsad>0){
          this.table2 = true;
        }
         if(this.totalRowsmpdjan>0){
          this.table3 = true;
        }
         if(this.totalRowsmpdsep>0){
          this.table4 = true;
        }
        }



        // this.isLoading = false;
      } catch (error) {
        console.log(error.response);
      }
    },

async loadcoulm(row) {
  const selectfile = row.selectfile && row.selectfile.value;
  const selecttab = row.selecttab;
  console.log(selectfile);
  const columns = [];
 let tempColumns = [];
   const hasColumn = (value) => columns.some(col => col.value === value);
  if (selectfile == 'arl') {

    selecttab.forEach((item, index) => {
      console.log(`Item ${index}:`, item.value);

      if (item.value == 'A_FLIGHT_DECK' || item.value == 'B_FLIGHT_DECK' || item.value == 'C_FLIGHT_DECK'  || item.value == 'D_FLIGHT_DECK' || item.value == 'E_FLIGHT_DECK'  || item.value == 'F_FLIGHT_DECK' || item.value == 'G_FLIGHT_DECK' || item.value == 'H_FLIGHT_DECK'  || item.value == 'I_FLIGHT_DECK'  || item.value == 'J_FLIGHT_DECK'  || item.value == 'X_FLIGHT_DECK'  || item.value == 'Z_FLIGHT_DECK') {
        tempColumns = [
          { value: 'mpd_mid', label: 'MPD MID' },
          { value: 'part_num_dis', label: 'Part Number Part Description' },
          { value: 'cage_code', label: 'Used On/Alt Authority Cage Code/SRC/ATA/LL/PV/AD' },
          { value: 'qty', label: 'Qty' },
          { value: 'serial', label: 'Serial/Lot Number/Dates' },
          { value: 'misc_loc', label: 'Misc Loc/Ref Designator X-Station/Y-BL/Z-Wtr' }
      ];
      }



     tempColumns.forEach(col => {
        if (!hasColumn(col.value)) {
          columns.push(col);
        }
      });
    });

    console.log("Columns:", columns);
    row.sectioncolum = columns;
  }else if(selectfile == 'airworthiness_directive'){
      selecttab.forEach((item, index) => {
      console.log(`Item ${index}:`, item.value);

      if (item.value == '1' || item.value == '2' || item.value == '3') {
        tempColumns = [
          { value: 'ad_number', label: 'AD Number Effective Date' },
          { value: 'amendment', label: 'Amendment' },
          { value: 'assigned', label: 'Assigned to' },
          { value: 'subject', label: 'Subject' },
          { value: 'compliance', label: 'Compliance/Limitations' },
          { value: 'additional_information', label: 'Follow-on Action / Additional Information' }
      ];
      }else if(item.value == '4'){
         tempColumns = [
          { value: 'ad_number', label: 'AD Number Effective Date' },
          { value: 'amendment', label: 'Amendment' },
          { value: 'assigned', label: 'Assigned to' },
          { value: 'subject', label: 'Subject' },

          { value: 'additional_information', label: 'Follow-on Action / Additional Information' }
      ];
      }



     tempColumns.forEach(col => {
        if (!hasColumn(col.value)) {
          columns.push(col);
        }
      });
    });

    console.log("Columns:", columns);
    row.sectioncolum = columns;
  }else if(selectfile == 'MPD_01-01-2024' || selectfile == 'MPD_15-09-2024'){
 selecttab.forEach((item, index) => {
      console.log(`Item ${index}:`, item.value);

      if (item.value == 'HIGHLIGHTS') {
        tempColumns = [
          { value: 'section', label: 'Section' },
          { value: 'item', label: 'Item' },
          { value: 'description_of_change', label: 'Description of Change' },

      ];
      }else if(item.value == 'SYSTEMS_AND_POWERPLANT_MAINTENA'){
         tempColumns = [
          { value: 'item_number', label: 'MPD ITEM NUMBER' },
          { value: 'amm_reference', label: 'AMM REFERENCE' },
          { value: 'cat', label: 'CAT' },
          { value: 'task', label: 'TASK' },
          { value: 'thres', label: 'THRE S.' },
          { value: 'repeat', label: 'REPEAT' },
          { value: 'zone', label: 'ZONE' },
          { value: 'access', label: 'ACCESS' },
          { value: 'apl', label: 'APL' },
          { value: 'eng', label: 'ENG' },
          { value: 'main_hours', label: 'MAIN-HOURS' },
          { value: 'description_of_change', label: 'TASK DESCRIPTION' }
      ];
      }else if(item.value == 'STRUCTURAL_MAINTENANCE_PROGRAM'){
         tempColumns = [
          { value: 'item_number', label: 'MPD ITEM NUMBER' },
          { value: 'amm_reference', label: 'AMM REFERENCE' },
          { value: 'pgm', label: 'PGM' },

          { value: 'thres', label: 'THRE S.' },
          { value: 'repeat', label: 'REPEAT' },
          { value: 'zone', label: 'ZONE' },
          { value: 'access', label: 'ACCESS' },
          { value: 'apl', label: 'APL' },
          { value: 'eng', label: 'ENG' },
          { value: 'main_hours', label: 'MAIN-HOURS' },
          { value: 'description_of_change', label: 'TASK DESCRIPTION' }
      ];
      }else if(item.value == 'ZONAL_INSPECTION_PROGRAM'){
         tempColumns = [
          { value: 'item_number', label: 'MPD ITEM NUMBER' },
          { value: 'amm_reference', label: 'AMM REFERENCE' },
            { value: 'thres', label: 'THRE S.' },
          { value: 'repeat', label: 'REPEAT' },
          { value: 'zone', label: 'ZONE' },
          { value: 'access', label: 'ACCESS' },
          { value: 'apl', label: 'APL' },
          { value: 'eng', label: 'ENG' },
          { value: 'main_hours', label: 'MAIN-HOURS' },
          { value: 'description_of_change', label: 'TASK DESCRIPTION' }
      ];
      }else if(item.value == 'TASKS_SORTED_BY_INTERVAL'){
         tempColumns = [


            { value: 'thres', label: 'THRE S.' },
          { value: 'repeat', label: 'REPEAT' },
             { value: 'item_number', label: 'MPD ITEM NUMBER' },
          { value: 'task_title', label: 'TASK TITLE' },

      ];
      }else if(item.value == 'TASKS_SORTED_BY_MPD_ITEM_NUMBER'){
         tempColumns = [
          { value: 'item_number', label: 'MPD ITEM NUMBER' },
          { value: 'mrb_item_number', label: 'MRB ITEM NUMBER' },
          { value: 'task_card_number', label: 'TASK CARD NUMBER' },
          { value: 'related_task_card_number', label: 'RELATED TASK CARD NUMBER' },
          { value: 'task', label: 'TASK' },
          { value: 'task_title', label: 'TASK TITLE' },

      ];
      }else if(item.value == 'TASKS_SORTED_BY_MRB_ITEM_NUMBER'){
         tempColumns = [
           { value: 'mrb_item_number', label: 'MRB ITEM NUMBER' },
          { value: 'item_number', label: 'MPD ITEM NUMBER' },

          { value: 'task_card_number', label: 'TASK CARD NUMBER' },
          { value: 'related_task_card_number', label: 'RELATED TASK CARD NUMBER' },
          { value: 'task', label: 'TASK' },
          { value: 'task_title', label: 'TASK TITLE' },

      ];
      }else if(item.value == 'TASKS_SORTED_BY_TASK_CARD_NUMBE'){
         tempColumns = [
              { value: 'task_card_number', label: 'TASK CARD NUMBER' },
                { value: 'item_number', label: 'MPD ITEM NUMBER' },
           { value: 'mrb_item_number', label: 'MRB ITEM NUMBER' },



          { value: 'related_task_card_number', label: 'RELATED TASK CARD NUMBER' },
          { value: 'task', label: 'TASK' },
          { value: 'task_title', label: 'TASK TITLE' },

      ];
      }



     tempColumns.forEach(col => {
        if (!hasColumn(col.value)) {
          columns.push(col);
        }
      });
    });

    console.log("Columns:", columns);
    row.sectioncolum = columns;
  }
},




   async loadtab(row) {
  const selectedValue = row.selectfile && row.selectfile.value;

    if (selectedValue === 'detailed_specification') {
      row.sections = [
        { label: 'Section 1', value: 'section1' },
        { label: 'Section 2', value: 'section2' },
        { label: 'Section 3', value: 'section3' },
        { label: 'Section 4', value: 'section4' }
      ];
    } else if (selectedValue === 'arl') {
      row.sections = [
        { label: 'Section A', value: 'A_FLIGHT_DECK' },
        { label: 'Section B', value: 'B_FLIGHT_DECK' },
        { label: 'Section C', value: 'C_FLIGHT_DECK' },
        { label: 'Section D', value: 'D_FLIGHT_DECK' },
        { label: 'Section E', value: 'E_FLIGHT_DECK' },
        { label: 'Section F', value: 'F_FLIGHT_DECK' },
        { label: 'Section G', value: 'G_FLIGHT_DECK' },
        { label: 'Section H', value: 'H_FLIGHT_DECK' },
        { label: 'Section I', value: 'I_FLIGHT_DECK' },
        { label: 'Section J', value: 'J_FLIGHT_DECK' },
        { label: 'Section X', value: 'X_FLIGHT_DECK' },
        { label: 'Section Z', value: 'Z_FLIGHT_DECK' }
      ];
    } else if (selectedValue === 'airworthiness_directive') {
      row.sections = [
        { label: 'Section 1', value: 1 },
        { label: 'Section 2', value: 2 },
        { label: 'Section 3', value: 3 },
        { label: 'Section 4', value: 4 }
      ];
    } else if (selectedValue === 'MPD_01-01-2024' || selectedValue === 'MPD_15-09-2024') {
      row.sections = [
        { label: 'HIGHLIGHTS', value: 'HIGHLIGHTS' },
        { label: 'SYSTEMS AND POWERPLANT MAINTENA', value: 'SYSTEMS_AND_POWERPLANT_MAINTENA' },
        { label: 'STRUCTURAL MAINTENANCE PROGRAM', value: 'STRUCTURAL_MAINTENANCE_PROGRAM' },
        { label: 'ZONAL INSPECTION PROGRAM', value: 'ZONAL_INSPECTION_PROGRAM' },
        { label: 'TASKS SORTED BY INTERVAL', value: 'TASKS_SORTED_BY_INTERVAL' },
        { label: 'TASKS SORTED BY MPD ITEM NUMBER', value: 'TASKS_SORTED_BY_MPD_ITEM_NUMBER' },
        { label: 'TASKS SORTED BY MRB ITEM NUMBER', value: 'TASKS_SORTED_BY_MRB_ITEM_NUMBER' },
        { label: 'TASKS SORTED BY TASK CARD NUMBER', value: 'TASKS_SORTED_BY_TASK_CARD_NUMBE' }
      ];
    } else {
      row.sections = []; // default empty
    }

    // Clear selected tabs when file changes
    row.selecttab = [];
  },


            handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    async SaveProduct() {
  if (!this.file) {
    alert("Please select an Excel file first.");
    return;
  }
  console.log(this.alldata.select);
  const formData = new FormData();
  formData.append("excel_file", this.file);
  formData.append("select_value", JSON.stringify(this.alldata.select));


  try {
    const response = await axios.post(
      "/mproduct/createexcelpdfmdp",
      formData,
      {
        headers: {
          Authorization: "Bearer " + this.access_token,
        "Content-Type": "multipart/form-data",
        //'Content-type': 'application/json',
        },
      }
    );

    const data = response;
      console.log(data);
    if (data.status == 200) {
      alert("Product data uploaded successfully!");
     // window.location.reload();

    } else {
      console.error("Upload failed:", data.message || data);
      alert("Upload failed. Please check the file format or server logs.");
    }
  } catch (error) {
    console.error("Upload error:", error.response || error);
    alert("An error occurred while uploading the file.");
  }
}





    },

    }

    </script>

    <style scoped>
.vs__dropdown-toggle {
      border-radius: 10px !important;
    border-top-left-radius: 10px !important;
    border-top-right-radius: 10px !important;
    border-bottom-right-radius: 10px !important;

}

    </style>
